import { createContext } from 'react';

const initialContext: any = {
  data: {},
  updateData: () => {},
};

const DataContext = createContext(initialContext);

export default DataContext;
